<ngx-loading-bar></ngx-loading-bar>
<app-opentimer-dialog></app-opentimer-dialog>
<app-opentimer-splash></app-opentimer-splash>
<router-outlet></router-outlet>
